/* eslint-disable no-console */
<template>
  <v-container>
    <div class="leads">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="green darken-1">
            <v-toolbar-title
              >Sie bearbeiten gerade Lead
              <span class="font-weight-bold">{{
                this.itemSelected.Name
              }}</span></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="close_dialog()"
                :disabled="disable_button_group"
                >verwerfen</v-btn
              >
              <v-btn
                dark
                text
                @click="save_lead()"
                :disabled="disable_button_group"
                >Änderungen übernehmen</v-btn
              >
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-subheader>Lead quick informations</v-subheader>
            <v-row class="mb-e6" style="max-height: 25vm">
              <v-col style="height: 50%">
                <v-list-item>
                  <v-list-item-content>
                    <v-col>
                      <v-btn
                        text
                        @click="call_lead(itemSelected.Telefon)"
                        :disabled="disable_button_group"
                        ><v-icon left>mdi-phone</v-icon>Anrufen</v-btn
                      >
                    </v-col>
                    <v-col>
                      <v-btn-toggle color="green accent" borderles>
                        <v-btn
                          v-show="disable_button_group"
                          @click="lead_not_reachable"
                          :value="2"
                        >
                          Nicht erreicht
                        </v-btn>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              v-show="disable_button_group"
                            >
                              Status
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in items"
                              :key="index"
                              @click="lead_not_interested(item.reasone)"
                            >
                              <v-list-item-title>{{
                                item.reasone
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <BauPicker
                          :show="disable_button_group"
                          :lead_id="itemSelected.id"
                          v-on:close="close_dialog()"
                        />
                        <v-btn
                          v-show="disable_button_group"
                          @click="export_lead_to_eva"
                        >
                          In Eva expotieren
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <p>Bereits versucht: {{ itemSelected.Versuche }}</p>
                    <br />
                    <v-textarea
                      label="Notizen"
                      maxlength="500"
                      outlined
                      v-model="itemSelected.notes"
                      :counter="500"
                    ></v-textarea>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col style="height: 50%">
                <v-list-item style="overflow-y: scroll">
                  <div style="max-height: 25rem">
                    <v-timeline>
                      <v-timeline-item v-for="item in history" :key="item.id">
                        <v-card>
                          <v-card-text>
                            {{ item.type }} : {{ item.salesperson }}
                          </v-card-text>
                          <v-card-subtitle
                            >{{ item.timestamp.slice(11, 16) }}
                            Uhr
                            <br />
                            {{
                              item.timestamp
                                .slice(0, 10)
                                .split('-')
                                .reverse()
                                .join('.')
                            }}</v-card-subtitle
                          >
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list>
          <v-divider></v-divider>
          <v-list three-line subheader>
            <v-subheader>General</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-row class="flex-md-col">
                  <v-col
                    cols="6"
                    v-for="(value, prop) in itemSelected"
                    :key="prop"
                  >
                    <v-text-field
                      :label="prop"
                      v-model="itemSelected[prop]"
                      outlined
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-btn
                      outlined
                      color="warning"
                      @click="lead_is_duplicated"
                      block
                    >
                      Duplicated lead
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>
      <v-container fill-height>
        <v-card style="width: 100%">
          <v-card-title>
            Leads –– {{ leads.length }}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="leads"
            :page.sync="page"
            :item-class="row_classes"
            :items-per-page="itemsPerPage"
            hide-default-footer
          >
            <template #header.id>
              <span class="bold">ID:</span><br />
            </template>
            <template #header.Timestamp> <span>Datum:</span><br /> </template>
            <template #header.Status>
              <span>Name:</span><br />
              <span>PLZ:</span><br />
              <span>Beschäftigung:</span><br />
            </template>
            <template #header.Name>
              <span class="bold">Kaufpreis:</span><br />
              <span class="bold">Finanzierungsbedarf:</span><br />
              <span class="bold">Einkommen:</span><br />
            </template>
            <template #header.Email>
              <span>Heute:</span><br />
              <span>Gesamt:</span><br />
            </template>
            <template #header.PLZ>
              <span>Finanzierungsgrund:</span><br />
              <span>Status:</span><br />
            </template>
            <template #header.Kaufpreis>
              <span>E-Mail:</span><br />
              <span>Telefon:</span><br />
            </template>
            <template v-slot:body="{ items }">
              <tbody class="bau-table">
                <tr
                  v-for="item in items"
                  :key="item.name"
                  :class="row_classes(item)"
                  @click="disable_row(item)"
                >
                  <td>
                    <span>{{ item.id }}</span> <br />
                    <span>{{ get_disabled(item.id) }}</span>
                  </td>
                  <td>
                    <v-badge
                      color="green"
                      :content="secondsToTime(parseInt(item.time, 10))"
                      v-if="item.time != null"
                    >
                      <span>{{
                        item.Timestamp.slice(0, 10)
                          .split('-')
                          .reverse()
                          .join('.')
                      }}</span>
                    </v-badge>
                    <span v-else>{{
                      item.Timestamp.slice(0, 10).split('-').reverse().join('.')
                    }}</span>
                    <br />
                    <span>{{ item.Timestamp.slice(11, 16) }} Uhr</span>
                  </td>
                  <td>
                    <v-badge color="red" v-if="item.vergleiche" content="v">
                      <span>{{ item.Name }} </span>
                    </v-badge>
                    <span v-else>{{ item.Name }} </span><br />
                    <span>{{ item.PLZ }}</span
                    ><br />
                    <span>{{ item.Beschaeftigungsverhaeltnis }}</span
                    ><br />
                  </td>
                  <td>
                    <span>{{ item.Kaufpreis }}</span
                    ><br />
                    <span>{{ item.Finanzierungsbedarf }}</span
                    ><br />

                    <span>{{ item.Einkommen }}</span
                    ><br />
                  </td>
                  <td>
                    <span>{{ item.called_today }}</span
                    ><br />
                    <span>{{ item.Versuche }}</span
                    ><br />
                  </td>
                  <td>
                    <span>{{ item.Objektart }}</span
                    ><br />
                    <span>{{ item.Status }}</span
                    ><br />
                  </td>
                  <td>
                    <span>{{ item.Email }}</span
                    ><br />
                    <span>{{ item.Telefon }}</span
                    ><br />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            @input="getLeads"
          ></v-pagination>
        </v-card>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BauPicker from '../components/UI/Date-picker.vue';
import axios from '../lib/api';
import socket from '../lib/socket';

export default {
  components: {
    BauPicker,
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { value: 'id' },
        { text: 'Datum' },
        { text: 'Status', value: 'Status' },
        { text: 'Name', value: 'Name' },
        { text: 'E-Mail', value: 'Email' },
        { text: 'PLZ / Ort', value: 'PLZ' },
        { text: 'Kaufpreis', value: 'Kaufpreis' },
      ],
      dialog: false,
      itemSelected: {},
      leads: [],
      history: [],
      disable_button_group: false,
      not_callable: 60,
      picker: new Date().toISOString().substr(0, 10),
      items: [
        { reasone: 'Objekt ist weg' },
        { reasone: 'Nur Informieren' },
        { reasone: 'Kein Interesse' },
        { reasone: 'Falsche Telefonnummer' },
      ],
    };
  },
  created() {
    window.addEventListener('beforeunload', this.close_dialog);
    this.getLeads();
    this.$store.dispatch('fetchDisabledLeads');

    const t = this;

    socket.on('new-leads', (data) => {
      if (data === true) {
        t.getLeads();
      }
    });

    socket.on('lead-created', (data) => {
      t.mergeAppointmentLeads(data[0]);
    });

    socket.on('make-invisible', (data) => {
      t.leads.splice(
        t.leads.findIndex((i) => {
          return i.id === data;
        }),
        1
      );
    });
  },
  mounted() {
    this.$store.dispatch('fetchDisabledLeads');
    this.getLeads();
  },

  computed: {
    ...mapGetters({
      user: 'user',
      recievedData: 'receivedLeads',
    }),
  },

  methods: {
    createdLeads() {},
    getLeads() {
      const t = this;
      axios.get(`/data?index=${t.page - 1}`).then((res) => {
        t.leads = res.data.data;
        t.pageCount = parseInt(res.data.count / 10 + 1, 10);
      });
    },

    mergeAppointmentLeads(lead) {
      const t = this;
      const leadsWithAppointment = [];
      const normalLeads = [];
      t.leads.forEach((value) => {
        if (value.termin) {
          leadsWithAppointment.push(value);
        } else {
          normalLeads.push(value);
        }
      });
      normalLeads.splice(-1, 1);
      normalLeads.unshift(lead);
      t.leads = leadsWithAppointment.concat(normalLeads);
    },

    disconnect() {
      socket.disconnect();
    },
    get_disabled(id) {
      let user;
      this.recievedData.forEach((i) => {
        if (i.id === id) {
          user = i.user;
        }
      });
      return user;
    },

    lead_not_interested(reasone) {
      const t = this;
      if (reasone === 'Falsche Telefonnummer') {
        axios
          .post('/history', {
            lead_id: this.itemSelected.id,
            action: '"Falsche Telefonnummer"',
            salesperson: this.user.data.email,
          })
          .then(() => {
            axios
              .post('/leads/update/wrong-phonenumber', {
                id: t.itemSelected.id,
                salesperson: t.user.data.id,
                versuche: +t.itemSelected.Versuche + 1,
                lead: {
                  email: t.itemSelected.Email,
                  phone: t.itemSelected.Telefon,
                  name: t.itemSelected.Name,
                  timestamp: t.itemSelected.Timestamp,
                },
              })
              .then(() => {
                this.close_lead();
              });
          });
      } else {
        axios
          .post('/history', {
            lead_id: this.itemSelected.id,
            action: `"Kein interesse" gedrückt grund: "${reasone}"`,
            salesperson: this.user.data.email,
          })
          .then(() => {
            axios
              .post('/leads/update/not-interest', {
                lead_id: t.itemSelected.id,
                action: `"Kein interesse" gedrückt grund: "${reasone}"`,
                versuche: t.itemSelected.Versuche,
              })
              .then(() => {
                this.close_lead();
              });
          });
      }
    },

    // Datatable functions
    row_classes(item) {
      let res = [item.termin ? 'red' : 'lead-row'];
      const set = new Set(this.recievedData);
      set.forEach((value) => {
        if (item.id === value.id) {
          res = ['grey', 'disabled'];
        }
      });
      return res;
    },
    disable_row(item) {
      if (this.itemSelected.user) {
        this.dialog = false;
      } else {
        socket.emit('lead', {
          id: item.id,
          user_id: this.user.data.id,
          user: this.user.data.email,
          state: 'editing',
        });
        this.$store.dispatch('fetchDisabledLeads');
        this.itemSelected = item;
        this.get_lead_history();
        this.dialog = true;
      }
    },
    secondsToTime(seconds) {
      const SECONDS_PER_DAY = 86400;
      const HOURS_PER_DAY = 24;

      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date((remainderSeconds + 3600) * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(
        /^(\d+)/,
        (h) => `${Number(h) + days * HOURS_PER_DAY}`
      );
    },

    // Dialog functions
    close_dialog() {
      axios
        .post('/history', {
          lead_id: this.itemSelected.id,
          action: '"Änderung verwerfen" gedrückt',
          salesperson: this.user.data.email,
        })
        .then(() => {
          this.close_lead();
        });
    },

    lead_is_duplicated() {
      axios
        .post('/history', {
          lead_id: this.itemSelected.id,
          action: '"Lead duplicated"',
          salesperson: this.user.data.email,
        })
        .then(() => {
          axios
            .post('/leads/update/not-interest', {
              lead_id: this.itemSelected.id,
              action: '"Lead duplicated"',
              versuche: 0,
            })
            .then(() => {
              this.close_lead();
            });
        });
    },

    open_dialog() {
      this.dialog = true;
    },

    save_lead() {
      axios
        .post('/history', {
          lead_id: this.itemSelected.id,
          action: '"Änderung übernehmen" gedrückt',
          salesperson: this.user.data.email,
        })
        .then(() => {
          this.update_lead();
          this.close_lead();
        });
    },
    export_lead_to_eva() {
      const t = this;

      if (t.itemSelected.vergleiche) {
        axios
          .post('/leads/exportLead', { id: this.itemSelected.id })
          .then(() => {
            axios.post('/history', {
              lead_id: this.itemSelected.id,
              action: 'Lead wurde zu EVA exportiert.',
              salesperson: this.user.data.email,
            });
            this.close_lead();

            socket.emit('unselect-lead', {
              id: this.itemSelected.id,
              user: this.user.data.email,
              state: 'removed',
            });
          });
      } else {
        axios
          .post('/leads/update/not-interest', {
            lead_id: t.itemSelected.id,
            action: 'Lead wurde zu EVA exportiert.',
            versuche: +t.itemSelected.Versuche + 1,
          })
          .then(() => {
            axios.post('/history', {
              lead_id: this.itemSelected.id,
              action: 'Lead wurde zu EVA exportiert.',
              salesperson: this.user.data.email,
            });
            this.close_lead();
            t.itemSelected.Versuche += 1;
          });
      }
    },
    // Lead functions
    update_lead() {
      axios.post('/leads/update/all', this.itemSelected).then(() => {
        this.$store.dispatch('fetchAllLeads');
      });
    },
    call_lead() {
      axios
        .post('/history', {
          lead_id: this.itemSelected.id,
          action: 'anrufen gedrückt',
          salesperson: this.user.data.email,
        })
        .then(() => {
          window.open(`tel:${this.itemSelected.Telefon}`);
          this.disable_button_group = !this.disable_button_group;
        });
    },
    get_lead_history() {
      const t = this;
      axios.get(`/history/all?id=${t.itemSelected.id}`).then((res) => {
        t.history = res.data;
      });
    },
    lead_not_reachable() {
      const t = this;

      axios
        .post('/leads/update/versuche', {
          id: t.itemSelected.id,
          salesperson: this.user.data.id,
          versuche: +t.itemSelected.Versuche + 1,
          lead: {
            email: t.itemSelected.Email,
            phone: t.itemSelected.Telefon,
            name: t.itemSelected.Name,
            timestamp: t.itemSelected.Timestamp,
          },
          extraTime: t.not_callable,
        })
        .then(() => {
          axios.post('/history', {
            lead_id: this.itemSelected.id,
            action: 'nicht erreicht gedrückt',
            salesperson: this.user.data.email,
          });

          this.close_lead();
          t.itemSelected.Versuche += 1;
        });
    },
    close_lead() {
      this.dialog = false;
      this.disable_button_group = false;
      // this.$store.dispatch('fetchAllLeads');
      this.update_lead();

      socket.emit('unselect-lead', {
        id: this.itemSelected.id,
        user_id: this.user.data.id,
        user: this.user.data.email,
        state: 'removed',
      });
    },
  },
};
</script>
<style lang="scss">
.bau-table tr,
.bau-table td,
.bau-table th {
  border: 0.25px solid rgba(0, 0, 0, 0.164);
}
.lead-row:nth-child(odd) {
  background: #edfaf0;
}

tr.grey.disabled {
  pointer-events: none;
}
</style>
